import { formatNumber } from './utils'

export const METRIC_INFO_MAP = {
  adns: {
    label: 'ADNS',
    type: 'money',
    isIncreasingPositive: true,
  },
  laborRatio: {
    label: 'Labor Ratio',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  speedOfService: {
    label: 'Speed of Service',
    type: 'number',
    isIncreasingPositive: false,
  },
  traffic: {
    label: 'Traffic',
    type: 'number',
    isIncreasingPositive: true,
  },
  avgCheck: {
    label: 'AOV',
    type: 'money',
    isIncreasingPositive: true,
  },
  totalDiscountsRatio: {
    label: 'Discounts',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  laborHours: {
    label: 'Labor Hours',
    type: 'hour',
    isIncreasingPositive: false,
  },
  wagePerHour: {
    label: 'Wage/hr',
    type: 'money',
    isIncreasingPositive: false,
  },
  overtimePercentage: {
    label: 'OT%',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  tipsPercentage: {
    label: 'Tips',
    type: 'percentage',
    isIncreasingPositive: true,
  },
  utilization: {
    label: 'Utilization',
    type: 'percentage',
    isIncreasingPositive: true,
  },
  windowTotal: {
    label: 'Window Time',
    type: 'hour',
    isIncreasingPositive: false,
  },
  serviceTotal: {
    label: 'Service Time',
    type: 'hour',
    isIncreasingPositive: false,
  },
  saleMix: {
    label: 'Sale Mix',
    type: 'percentage',
    isIncreasingPositive: true,
  },
  marginPercentage: {
    label: 'Margin Impact',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  cogsPercentage: {
    label: 'COGS',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  ptiPercentage: {
    label: 'PTI',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  compliancePercentage: {
    label: 'Compliance',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  cogsVsTheoretical: {
    label: 'vs Theoretical',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  // Sales Lens
  netSalesAmount: {
    label: 'Daily Sales',
    type: 'money',
    isIncreasingPositive: true,
  },
  netSalesPercentage: {
    label: '% of Total Sales',
    type: 'percentage',
    isIncreasingPositive: true,
  },
  unitSold: {
    label: 'Unit Sold',
    type: 'number',
    isIncreasingPositive: true,
  },
  avgSellingPrice: {
    label: 'Avg Selling Price',
    type: 'money',
    isIncreasingPositive: true,
  },
  grossToDiscountPercentage: {
    label: 'Discounts %',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  // Material Code Lens
  totalSpend: {
    label: 'Total Spend',
    type: 'money',
    isIncreasingPositive: false,
  },
  spendSharePercentage: {
    label: 'Spend Share',
    type: 'percentage',
    isIncreasingPositive: false,
  },
  averageUnitPrice: {
    label: 'Average Price/Unit',
    type: 'money',
    isIncreasingPositive: false,
  },
  activeSkuCount: {
    label: '# of Active SKUs',
    type: 'number',
    isIncreasingPositive: true,
  },
  theoreticalActual: {
    label: 'Theoretical vs Actual',
    type: 'percentage',
    isIncreasingPositive: true,
  },
}

export const getMetricLabel = (metric: string | number | symbol) => {
  if (METRIC_INFO_MAP.hasOwnProperty(metric)) {
    return METRIC_INFO_MAP[metric as keyof typeof METRIC_INFO_MAP].label
  }
  return metric as string
}

export const getMetricType = (metric: string | number | symbol) => {
  if (METRIC_INFO_MAP.hasOwnProperty(metric)) {
    return METRIC_INFO_MAP[metric as keyof typeof METRIC_INFO_MAP].type
  }
  return 'number'
}

export const getMetricIsIncreasingPositive = (
  metric: string | number | symbol
) => {
  if (METRIC_INFO_MAP.hasOwnProperty(metric)) {
    return METRIC_INFO_MAP[metric as keyof typeof METRIC_INFO_MAP]
      .isIncreasingPositive
  }
  return true
}

export const getFormattedMetricString = (
  metric: string | number | symbol,
  value: number
) => {
  const type = getMetricType(metric)

  return formatNumber(value, type as 'money' | 'percentage' | 'number' | 'hour')
}
